import React from 'react'
import {
  Dialog as MUIDialog,
  DialogActions as MUIDialogActions,
  DialogContent as MUIDialogContent,
  DialogContentText as MUIDialogContentText,
  DialogTitle as MUIDialogTitle,
} from '@material-ui/core'

export const Dialog = ({ children, ...props }) => <MUIDialog {...props}>{children}</MUIDialog>
export const DialogActions = ({ children, ...props }) => (
  <MUIDialogActions {...props}>{children}</MUIDialogActions>
)
export const DialogContent = ({ children, ...props }) => (
  <MUIDialogContent {...props}>{children}</MUIDialogContent>
)
export const DialogContentText = ({ children, ...props }) => (
  <MUIDialogContentText {...props}>{children}</MUIDialogContentText>
)
export const DialogTitle = ({ children, ...props }) => (
  <MUIDialogTitle {...props}>{children}</MUIDialogTitle>
)
